import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Heart, X } from "lucide-react";

export default function LiveEventsDialog() {
  const [live, setLive] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("svss_live_seen") === "1") return;
    api.get("/events").then(({ data }) => {
      const liveEvents = (data || []).filter((e) => e.is_live);
      if (liveEvents.length > 0) {
        setLive(liveEvents);
        setOpen(true);
      }
    }).catch(() => {});
  }, []);

  const close = () => { sessionStorage.setItem("svss_live_seen", "1"); setOpen(false); };

  if (live.length === 0) return null;

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="sm:max-w-lg bg-[#FAF7F2] border-[#E8DEC8]" data-testid="live-events-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <span className="pill-live rounded-full px-3 py-1 text-xs font-bold uppercase">● LIVE NOW</span>
          </div>
          <DialogTitle className="font-serif text-2xl text-[#5C061C]">Ongoing seva at the Sanstha</DialogTitle>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          {live.map((e) => (
            <div key={e.id} className="card-warm rounded-xl overflow-hidden flex" data-testid={`live-event-${e.id}`}>
              {e.image_url && <img src={e.image_url} alt="" className="h-24 w-24 object-cover shrink-0" />}
              <div className="p-3 flex-1">
                <p className="font-serif text-lg text-[#5C061C] leading-tight">{e.title}</p>
                <p className="text-xs text-[#6E6259] mt-1 line-clamp-2">{e.description}</p>
                <div className="flex gap-2 mt-2">
                  <Link to={`/events/${e.id}`} onClick={close}>
                    <Button size="sm" variant="outline" className="h-8 border-[#5C061C] text-[#5C061C]" data-testid={`live-view-${e.id}`}>View</Button>
                  </Link>
                  <Link to="/events" onClick={close}>
                    <Button size="sm" className="btn-saffron h-8" data-testid={`live-contribute-${e.id}`}><Heart className="h-3 w-3 mr-1" /> Contribute</Button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <Button variant="ghost" onClick={close} className="text-[#6E6259]" data-testid="live-dialog-close">
            <X className="h-4 w-4 mr-1" /> Continue browsing
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
